import React from 'react';
import './Founders.css';

const Founders = () => {
  const founders = [
    {
      name: 'Nagalakshmi',
      title: 'CEO/Founder',
      description: 'Developer and Machine Learning specialist building cutting-edge solutions.',
      achievement: 'Expert in development and ML technologies'
    },
    {
      name: 'Sukitha',
      title: 'CEO/Founder',
      description: 'Developer and Machine Learning expert creating intelligent systems.',
      achievement: 'Specialized in development and ML integration'
    },
    {
      name: 'Yobhashini',
      title: 'CEO/Founder',
      description: 'Innovative leader driving technology solutions and business growth.',
      achievement: 'Leading strategic initiatives and innovation'
    },
    {
      name: 'Sabari Kannan',
      title: 'CEO/Founder',
      description: 'Frontend Developer crafting beautiful and functional user experiences.',
      achievement: 'Expert in modern frontend technologies'
    },
    {
      name: 'Vigneshwar',
      title: 'CEO/Founder',
      description: 'Machine Learning expert driving innovation through AI and advanced algorithms.',
      achievement: 'Leading ML initiatives and AI solutions'
    },{
      name: 'Sundhara Chozhan',
      title: 'CEO/Founder',
      description: 'MERN Stack Developer creating innovative applications and solutions.',
      achievement: 'Tech Lead in MERN stack development'
    },
    {
      name: 'Thavasi',
      title: 'CEO/Founder',
      description: 'Data Scientist extracting insights and driving data-driven decisions.',
      achievement: 'Expert in data science and predictive modeling'
    }
  ];

  return (
    <section id="founders" className="founders">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Founders</h2>
          <p className="section-subtitle">The Visionaries Behind Veltroz</p>
        </div>
        <div className="founders-grid">
          {founders.map((founder, index) => (
            <div key={index} className="founder-card">
              <div className="founder-image">
                <div className="founder-avatar">
                  {founder.name.split(' ').map(n => n[0]).join('')}
                </div>
              </div>
              <div className="founder-content">
                <h3 className="founder-name">{founder.name}</h3>
                <p className="founder-title">{founder.title}</p>
                <p className="founder-description">{founder.description}</p>
                <div className="founder-achievement">
                  <span className="achievement-icon">🏆</span>
                  <span className="achievement-text">{founder.achievement}</span>
                </div>
                {/* <div className="founder-social">
                  <a href="#" aria-label="LinkedIn" className="social-link">LinkedIn</a>
                </div> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Founders;

